import { attachToken, privateAPI } from "../../config/constants";
import { notification } from "antd";
import store from "..";

import { setRewards, setLoading } from "../slices/rewardSlice";
import { CreateRewardType } from "../interfaces/Reward";

const handleError = (error: any) => {
  console.log(error?.response?.data?.message);
  notification.error({
    message: error?.response?.data?.message || "Server error",
  });
};

const Created = "Reward Created Successfully";
const Updated = "Reward Updated Successfully";
const Deleted = "Reward Deleted Successfully";

export const createRewards = async (payload: CreateRewardType) => {
  try {
    attachToken();
    store.dispatch(setLoading(true));
    const response = await privateAPI.post("/rewards/create", payload);
    if (response) {
      notification.success({
        message: response?.data?.data?.message || Created,
      });
    }
    return response;
  } catch (error: any) {
    handleError(error);
  } finally {
    store.dispatch(setLoading(false));
  }
};

export const getRewards = async () => {
  try {
    attachToken();
    store.dispatch(setLoading(true));
    const response = await privateAPI.get("/rewards/get");
    if (response) {
      store.dispatch(setRewards(response?.data?.data));
    }
    return response?.data;
  } catch (error: any) {
    handleError(error);
  } finally {
    store.dispatch(setLoading(false));
  }
};

export const updateReward = async (payload: CreateRewardType) => {
  try {
    attachToken();
    store.dispatch(setLoading(true));
    const response = await privateAPI.put("/rewards/update", payload);
    if (response) {
      notification.success({
        message: response?.data?.data?.message || Updated,
      });
    }
    return response;
  } catch (error: any) {
    handleError(error);
  } finally {
    store.dispatch(setLoading(false));
  }
};

export const deleteReward = async (id: string) => {
  try {
    attachToken();
    const response = await privateAPI.post(`/rewards/delete`, { _id: id });
    notification.success({
      message: response?.data?.data?.message || Deleted,
    });
    return response;
  } catch (error: any) {
    handleError(error);
  }
};
